import { render, staticRenderFns } from "./MetaInfo.vue?vue&type=template&id=f0aa226c&scoped=true&"
import script from "./MetaInfo.vue?vue&type=script&lang=js&"
export * from "./MetaInfo.vue?vue&type=script&lang=js&"
import style0 from "./MetaInfo.vue?vue&type=style&index=0&id=f0aa226c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0aa226c",
  null
  
)

export default component.exports